import { gql } from '@apollo/client/core'

export const keywordAutoSuggestionQuery = gql`
  query keywordAutoSuggestion(
    $keyword: String!
  ) {
  keywordAutoSuggestion(
    keyword: $keyword
  ) {
    items
    }
  }
`

export const addToFavoriteMutation = gql`
mutation addToFavorite($input: AddToFavoriteInput!) {
  addToFavorite(input: $input) {
    errors
    estimateItemId
    success
  }
}
`

export const removeFromFavoriteMutation = gql`
mutation removeFromFavorite($input: RemoveFromFavoriteInput!) {
  removeFromFavorite(input: $input) {
    errors
    success
  }
}
`

export const getFavoriteCountQuery = gql`
  query getFavoriteCount {
    applicationData {
      favoritesCount
    }
  }
`
